import React from 'react';

import { Icon } from '../icons';

export const ImageIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M26 24.124v.839c0 1.389-1.12 2.515-2.5 2.515h-20c-1.38 0-2.5-1.126-2.5-2.515V11.547c0-1.39 1.12-2.516 2.5-2.516h.833v2.516h-.52a.313.313 0 00-.313.314v12.787c0 .174.14.315.313.315h19.375c.172 0 .312-.141.312-.315v-.524H26zm2.188-17.608H8.813a.313.313 0 00-.313.314v12.787c0 .174.14.315.313.315h19.374c.173 0 .313-.141.313-.315V6.83a.313.313 0 00-.313-.314zM28.5 4C29.88 4 31 5.126 31 6.516v13.416c0 1.389-1.12 2.515-2.5 2.515h-20c-1.38 0-2.5-1.126-2.5-2.515V6.516C6 5.126 7.12 4 8.5 4h20zM14.75 9.87a2.09 2.09 0 01-2.083 2.096 2.09 2.09 0 01-2.084-2.096 2.09 2.09 0 012.084-2.097A2.09 2.09 0 0114.75 9.87zM11 14.9l2.058-2.07a.622.622 0 01.884 0L16 14.9l5.391-5.424a.622.622 0 01.884 0L26 13.224v4.192H11v-2.515z" />
    </svg>
  );
};
